import { render, staticRenderFns } from "./UHF-DVS-50.vue?vue&type=template&id=784200b3&scoped=true&lang=pug"
import script from "./UHF-DVS-50.vue?vue&type=script&lang=js"
export * from "./UHF-DVS-50.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784200b3",
  null
  
)

export default component.exports